import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'meterDashOffset',
  standalone: true,
})
export class MeterDashOffsetPipe implements PipeTransform {
  transform(score: number, circumference: number): number {
    return circumference * (1 - Math.min(score, 100) / 100);
  }
}
